// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config$LiveRoom from "../../Config.bs.js";
import * as Segment$LiveRoom from "./Segment.bs.js";
import * as BrowserLogs from "@datadog/browser-logs";

function withOneTrustConsent(cb) {
  if (Segment$LiveRoom.hasOneTrustConsent(undefined)) {
    return Curry._1(cb, undefined);
  }
  
}

function debug(message, extra, err, param) {
  withOneTrustConsent(function (param) {
        BrowserLogs.datadogLogs.logger.debug(message, extra, err);
      });
}

function info(message, extra, err, param) {
  withOneTrustConsent(function (param) {
        BrowserLogs.datadogLogs.logger.info(message, extra, err);
      });
}

function warn(message, extra, err, param) {
  withOneTrustConsent(function (param) {
        BrowserLogs.datadogLogs.logger.warn(message, extra, err);
      });
}

function error(message, extra, err, param) {
  withOneTrustConsent(function (param) {
        BrowserLogs.datadogLogs.logger.error(message, extra, err);
      });
}

var Logger = {
  withOneTrustConsent: withOneTrustConsent,
  debug: debug,
  info: info,
  warn: warn,
  error: error
};

function isEnabled(param) {
  return !(Config$LiveRoom.tier === "Local" || Config$LiveRoom.tier === "Dev" || Config$LiveRoom.tier === "LocalWithClientAPI");
}

function Datadog$Provider(props) {
  React.useEffect((function () {
          Curry._1(BrowserLogs.datadogLogs.init, {
                clientToken: Config$LiveRoom.values.datadog.token,
                site: Config$LiveRoom.values.datadog.site,
                env: Config$LiveRoom.values.datadog.environment,
                service: Config$LiveRoom.values.datadog.serviceName,
                forwardErrorsToLogs: false
              });
        }), []);
  return props.children;
}

var Provider = {
  make: Datadog$Provider
};

export {
  Logger ,
  isEnabled ,
  Provider ,
}
/* react Not a pure module */
